import {add, list, onChange, quantity, remove, destroy} from 'cart-localstorage';
import {CartOrderModal} from "../../../Integration/Molecule/CartOrderModal/CartOrderModal";

export default class FloatingCart {
    static init() {
        new FloatingCart();
    }

    constructor() {
        let addToCartLinks = document.querySelectorAll('.product-card__link[data-id]');
        if (addToCartLinks.length === 0) return;

        this.isOpen = false;
        this.position = ['floating-cart--is-right', 'floating-cart--is-bottom'];
        this.cartContent = new FloatingCartContent();
        this.cartContent.setCheckoutLink(addToCartLinks[0].dataset.checkoutLink); // getting checkout link from first product card
        this.element = this.render();
        document.body.appendChild(this.element);
        this.element.classList[list().length === 0 ? 'add' : 'remove']('floating-cart--is-empty');

        window.addEventListener('click', e => {
            if (e.target.closest('.product-card__link[data-id]')) {
                let el = e.target;
                e.preventDefault();
                e.stopPropagation();
                el.removeAttribute('data-checkout-link'); // remove unnecessary attribute
                add(el.dataset);

                let isBuyNowLink = el.classList.contains('product-card__link--is-buy-now');

                if (isBuyNowLink) {
                    // window.location.href = el.href;
                    CartOrderModal.reloadIframeAndOpen();
                }
            }

            let isAddToCartLink = e.target.closest('.product-card__link');
            if (isAddToCartLink) return; // do nothing

            let isCartClick = e.target.closest('.floating-cart');
            if (isCartClick) {
                e.stopPropagation();
                e.preventDefault();
                this.element.classList.add('floating-cart--is-open')
                this.isOpen = true;
            } else {
                this.element.classList.remove('floating-cart--is-open');
                this.isOpen = false;
            }

            if (e.target.classList.contains('floating-cart__content__close')) {
                this.element.classList.remove('floating-cart--is-open');
                this.isOpen = false;
            }

            if (e.target.classList.contains('floating-cart__content__item__controls__button--decrease')) {
                quantity(e.target.closest('.floating-cart__content__item').id, -1);
            }

            if (e.target.classList.contains('floating-cart__content__item__controls__button--increase')) {
                quantity(e.target.closest('.floating-cart__content__item').id, 1);
            }

            if (e.target.classList.contains('floating-cart__content__item__controls__button--remove')) {
                remove(e.target.closest('.floating-cart__content__item').id);
            }
        });

        onChange(() => {
            this.element.classList[list().length === 0 ? 'add' : 'remove']('floating-cart--is-empty');
            this.update();
        });

        window.addEventListener('message', function(event) {
            if (event.data === 'resetCart') {
                destroy()
            }
        })
    }

    render() {
        let cartElement
        if (document.body.querySelector('.floating-cart')) {
            cartElement = document.body.querySelector('.floating-cart');
        } else {
            cartElement = document.createElement('div');
            cartElement.classList.add(...this.position);
            cartElement.classList.add('floating-cart');
        }

        this.isOpen ? cartElement.classList.add('floating-cart--is-open') : null;
        cartElement.appendChild(this.cartContent.element);

        return cartElement;
    }

    update() {
        this.cartContent.update();
    }

    getTotalPrice() {
        return this.cartContent.getTotalPrice();
    }
}

class FloatingCartContent {
    constructor() {
        this.lang = document.documentElement.lang || 'de';
        this.priceFormatOptions = {style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2};
        this.data = list();
        this.badge = new FloatingCartBadge();
        this.element = this.render();
    }

    render() {
        let contentElement = document.createElement('div');
        contentElement.classList.add('floating-cart__content');
        contentElement.innerHTML = `
            <button type="button" class="floating-cart__content__close"></button>
            <div class="floating-cart__content__body"></div>
            <div class="floating-cart__content__footer"></div>`;

        this.contentBodyElement = contentElement.querySelector('.floating-cart__content__body');
        this.contentFooterElement = contentElement.querySelector('.floating-cart__content__footer');

        contentElement.appendChild(this.badge.element);
        this.contentBodyElement.appendChild(this.renderList());
        this.contentFooterElement.appendChild(this.renderTotalPrice());
        this.contentFooterElement.appendChild(this.renderCheckoutButton());

        return contentElement;
    }

    renderList() {
        let cartContentListElement = document.createElement('ul');
        cartContentListElement.classList.add('floating-cart__content__list');

        this.data.forEach(item => {
            let itemElement = new FloatingCartContentItem(item).render();
            cartContentListElement.appendChild(itemElement);
        });

        this.cartContentListElement = cartContentListElement;
        return cartContentListElement;
    }

    renderTotalPrice() {
        let totalPriceElement = document.createElement('div');
        totalPriceElement.classList.add('floating-cart__content__total-price');
        totalPriceElement.innerHTML = `
            <span class="floating-cart__content__total-price__label">Total</span>
            <span class="floating-cart__content__total-price__number">${this.getTotalPrice().toLocaleString(this.lang, this.priceFormatOptions)}</span>`;
        this.cartContentTotalPriceElement = totalPriceElement;
        return totalPriceElement;
    }

    renderCheckoutButton() {
        let checkoutButtonElement = document.createElement('button');
        checkoutButtonElement.setAttribute('type', 'button');
        checkoutButtonElement.classList.add('button', 'is-small', 'is-primary', 'floating-cart__content__button--is-checkout');
        checkoutButtonElement.textContent = document.body.dataset.checkoutLabel;

        checkoutButtonElement.addEventListener('click', e => {
            CartOrderModal.reloadIframeAndOpen()
        });

        this.cartContentCheckoutButtonElement = checkoutButtonElement;


        return checkoutButtonElement;
    }

    setCheckoutLink (link) {
        this.cartContentCheckoutButtonElement.href = link;
    }

    getTotalPrice() {
        let totalPrice = 0;
        let subTotal = 0;

        this.data.forEach(item => {
            subTotal = ((parseFloat(item.price).toFixed(2) * 100) * parseInt(item.quantity) / 100).toFixed(2);
            totalPrice += parseFloat(subTotal);
        });

        return parseFloat(totalPrice);
    }

    update() {
        this.data = list();
        this.cartContentListElement.replaceWith(this.renderList());
        this.cartContentTotalPriceElement.replaceWith(this.renderTotalPrice());
        this.badge.update();
    }
}

class FloatingCartContentItem {
    constructor(data) {
        if (!data) return;

        this.lang = document.documentElement.lang || 'de';
        this.priceFormatOptions = {style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2};
        this.data = data;
        this.id = this.data.id;
        this.element = this.render();
    }

    getSubtotal() {
        return parseFloat(((parseFloat(this.data.price).toFixed(2) * 100) * parseInt(this.data.quantity) / 100).toFixed(2));
    }

    render() {
        let itemElement = document.createElement('li');
        itemElement.classList.add('floating-cart__content__item');
        itemElement.id = this.id;
        itemElement.innerHTML = `
            <div class="floating-cart__content__item__body">
                <a href="${this.data.url || '#'}" class="floating-cart__content__item__header" title="${this.data.title}">
                    <img class="floating-cart__content__item__image" alt="product-image" src="${this.data.imageSource}" />
                    <span class="floating-cart__content__item__title">${this.data.title} <strong>${this.data.releaseDate ? '(' + this.data.releaseDate + ')' : ''}</strong></span>
                </a>
            </div>
            <div class="floating-cart__content__item__footer">
                <div class="floating-cart__content__item__prices">
                    <span class="floating-cart__content__item__price">${parseFloat(this.data.price).toLocaleString(this.lang, this.priceFormatOptions)}</span>
                    <span class="floating-cart__content__item__subtotal">${this.getSubtotal().toLocaleString(this.lang, this.priceFormatOptions)}</span>
                </div>
                <div class="floating-cart__content__item__controls">
                    <button type="button" class="floating-cart__content__item__controls__button floating-cart__content__item__controls__button--decrease">-</button>
                    <input readonly class="floating-cart__content__item__controls__input" type="number"/>
                    <button type="button" class="floating-cart__content__item__controls__button floating-cart__content__item__controls__button--increase">+</button>
                    <button class="floating-cart__content__item__controls__button floating-cart__content__item__controls__button--remove" title="Remove from cart">x</button>
                </div>
            </div>`;

        // Poor man's remove image if no image source is set
        if (!this.data.imageSource) {
            const image = itemElement.querySelector('.floating-cart__content__item__image')
            if (image) {
                image.parentNode.removeChild(image)
            }
        }

        let itemInputElement = itemElement.querySelector('input');
        itemInputElement.value = this.data.quantity;

        return itemElement;
    }

    decreaseQuantity() {
        quantity(this.id, -1);
    }

    increaseQuantity() {
        quantity(this.id, 1);
    }

    remove() {
        remove(this.id);
    }

    update() {
        if (this.element) {
            this.element.replaceWith(this.render());
        }
        this.element = this.render();
    }
}

class FloatingCartBadge {
    constructor() {
        this.data = list();
        this.element = this.render();
    }

    render() {
        let badgeElement;

        if (this.element) {
            badgeElement = this.element;
        } else {
            badgeElement = document.createElement('span');
            badgeElement.classList.add('badge');
        }

        badgeElement.innerHTML = this.getTotalQuantity();

        return badgeElement;
    }

    getTotalQuantity() {
        let totalQuantity = 0;
        this.data.forEach(item => {
            totalQuantity += parseInt(item.quantity);
        });

        return totalQuantity;
    }

    update() {
        this.data = list();
        this.element.replaceWith(this.render());
        this.element = this.render();
    }
}
